<div class="mat-typography" *ngIf="statistic?.length; else noRecords">
    <div *ngFor="let statusStat of statistic" style="display: flex; margin-bottom: 3px;">
        <div style="width:80px">{{getPrettyZCStatus(statusStat.status)}}:</div>
        <div>{{statusStat.count | number}}</div>
    </div>
</div>

<ng-template #noRecords>
    <div class="mat-typography">No records</div>
</ng-template>